import { DepreciationBasis } from '@assetaccountant/api/models/depreciation-basis';

export class DepreciationMethodSettings {
  isLifeEditable: boolean;
  isLifeApplicable: boolean;
  defaultLife?: number | null;
  lifeValues?: number[] | null;
  isLifeFreeInput: boolean;
  isUnitsOfUse: boolean;

  isRateEditable: boolean;
  isRateApplicable: boolean;
  autoCalculateRate: boolean;
  defaultRate?: number | null;

  isOriginalDateApplicable: boolean;
  isOriginalCostApplicable: boolean;
  isResidualValueApplicable: boolean;
  basis: DepreciationBasis;

  static default = (): DepreciationMethodSettings => ({
    isRateEditable: true,
    isRateApplicable: true,
    isLifeEditable: true,
    isLifeApplicable: true,
    autoCalculateRate: false,
    isLifeFreeInput: true,
    isUnitsOfUse: false,
    isOriginalDateApplicable: false,
    isOriginalCostApplicable: false,
    isResidualValueApplicable: false,
    basis: DepreciationBasis.Value,
  });
}
